import { parseError, isSessionExpiredError } from '../helpers/errors'
import { hasSessionEnded } from './sessionBridge'

export const ADD_ERROR = 'ERRORS/ADD'
export const addError = (name, error) => {
  const parsed = parseError(error, { name })

  return {
    type: ADD_ERROR,
    error: parsed,
    handledBySessionDialog: isSessionExpiredError(parsed) && hasSessionEnded()
  }
}

export const REMOVE_ERROR = 'ERRORS/REMOVE'
export const removeError = id => ({
  type: REMOVE_ERROR,
  id
})
